// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XX1W","question":"styles_question__1_FDh","description":"styles_description__1qZP4"};